module.exports = __webpack_public_path__ + "static/image/service/pc/robot@3x.jpg?311e3d0d";